// eslint-disable-next-line @typescript-eslint/no-unused-vars
import VenueDefinition from "../../VenueDefinition";
import ConferenceGame from "../../../ConferenceGame";
import BootScene from "../../BootScene";
import {ConferenceGameWrapper} from "../main/MainVenue";
import LiveWorldScene from "../../LiveWorldScene";
import DancePartyWorldScene from "../main/DancePartyWorldScene";
import {EventIntf} from "../../../ServerTypes";

export default class PartyVenue extends VenueDefinition {
    constructor(event: EventIntf) {
        super(event)
    }

    createScenes(gameHost: ConferenceGame): Phaser.Scene[] {
        let gameWrapper = new ConferenceGameWrapper(gameHost);
        return [
            new BootScene(gameWrapper, this, null, "firstWorld"),
            new LiveWorldScene(
                "firstWorld",
                "mainroom",
                false,
                gameWrapper,
                this),
            new LiveWorldScene(
                "vipRoom",
                "vipRoom",
                false,
                gameWrapper,
                this),
            new DancePartyWorldScene(
                "secretRoom",
                "secretRoom",
                false,
                gameWrapper,
                this),
        ];
    }

    postload(scene: Phaser.Scene): void {
    }

    preload(scene: Phaser.Scene): void {
        scene.load.plugin('rexcirclemaskimageplugin', 'https://raw.githubusercontent.com/rexrainbow/phaser3-rex-notes/master/dist/rexcirclemaskimageplugin.min.js', true);

        // map tiles
        scene.load.image('maptiles', '/assets/maps/tileset-32px-extruded.png');
        scene.load.tilemapTiledJSON('mainroom', '/assets/maps/party/mainroom.json');
        scene.load.tilemapTiledJSON('vipRoom', '/assets/maps/main/vip-room.json');

        // our two characters
        scene.load.spritesheet('player', '/assets/RPG_assets.png', {
            frameWidth: 32,
            frameHeight: 32
        });

        scene.load.spritesheet('tv', '/assets/TV_animation.png', {
            frameWidth: 50,
            frameHeight: 50
        });

        // chat bubbles
        scene.load.spritesheet('chatBubbles', '/assets/bubble_assets.png', {
            frameWidth: 26,
            frameHeight: 24
        });

        scene.load.audio('clunk', [
            '/assets/audio/clunk.ogg',
            '/assets/audio/clunk.mp3'
        ]);

        scene.load.audio('mario', [
            '/assets/audio/mario2.ogg',
            '/assets/audio/mario2.mp3'
        ]);

        scene.load.audio('dance', [
            '/assets/audio/dance.ogg',
            '/assets/audio/dance.mp3'
        ]);

        scene.load.bitmapFont("gamefont", "/assets/gamefont.png", "/assets/gamefont.fnt");

        // our two characters
        scene.load.spritesheet('dancers', '/assets/Dancing_assets.png', {
            frameWidth: 56,
            frameHeight: 56
        });

        scene.load.image('talkRadius', '/assets/images/talkRadius.png');
        scene.load.image('empty', '/assets/images/empty.png');
    }
}
